import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { primary, secondary }
  } = theme;

  return {
    dialog: {
      width: 300
    },
    dialogTitle: {
      padding: "26px 24px",
      fontWeight: "bold",
      "& .MuiTypography-h6": {
        fontFamily:
          '"Helvetica-Bold", "Helvetica Bold", "Helvetica", sans-serif',
        fontWeight: 700
      }
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      gap: 20,
      fontSize: "14px",
      padding: "0 15px"
    },
    dialogContentExtraPadding: {
      padding: "0 9px"
    },
    dialogCalendar: {
      "& $dialogTitle": {
        color: theme.palette.common.black
      }
    },
    reportTypeForm: {
      "& .MuiInputBase-root": {
        borderRadius: 3
      },
      "& .MuiSelect-outlined.MuiSelect-outlined": {
        paddingRight: 0
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "#1px solid #ccc"
      },
      "&.selectedValue .MuiOutlinedInput-notchedOutline": {
        borderColor: primary.main
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${secondary.dark}`
      },
      "&.expanded .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${secondary.dark}`
      },
      "&.selectedValue .MuiSelect-icon": {
        color: primary.main
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiSelect-icon": {
        color: secondary.dark
      },
      "& .MuiInputLabel-outlined": {
        color: "#2d2d2d",
        fontSize: 12,
        transform: "translate(14px, 12px)"
      },
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.9)"
      }
    },
    reportTypeSelect: {
      fontSize: "14px",
      marginTop: 8,
      "& .MuiOutlinedInput-input": {
        padding: "12px"
      }
    },
    selectList: {
      padding: 0,
      boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.25)",
      borderRadius: 3,
      "& .MuiListItem-root": {
        fontSize: 14,
        color: primary.main,
        minHeight: 39,
        borderBottom: "1px solid #eee",
        whiteSpace: "initial",
        "&.Mui-selected": {
          backgroundColor: "rgba(97, 198, 158, 0.15)"
        },
        "&:last-child": {
          borderBottom: "none"
        }
      }
    },
    selectPaper: {
      width: "min-content",
      "&.MuiPaper-elevation8": {
        boxShadow:
          "0px -5px 10px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)"
      }
    },
    dateRangeItem: {
      display: "flex",
      cursor: "pointer",
      alignItems: "center",
      width: "100%",
      flexWrap: "wrap"
    },
    radio: {
      color: primary.main,
      marginRight: 2,
      "&.MuiRadio-colorSecondary": {
        color: "#eee"
      },
      "&.MuiRadio-colorSecondary.Mui-checked": {
        color: "#02c092"
      },
      "& .MuiSvgIcon-root": {
        width: 26,
        height: 26
      }
    },
    dateRangeText: {
      fontSize: "16px"
    },
    dateRangeSelectButton: {
      color: theme.palette.secondary.dark,
      textTransform: "none",
      padding: "0 4px",
      marginLeft: 42,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    dialogActions: {
      padding: "24px",
      flexGrow: 1
    },
    buttons: {
      display: "flex",
      justifyItems: "flex-end",
      gap: 32
    },
    button: {
      fontSize: 14,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    downloadButton: {
      color: theme.palette.secondary.dark
    },
    goBackButton: {
      color: theme.palette.text.secondary
    },
    loaderDownloading: {
      position: "absolute",
      backgroundColor: "#fff",
      opacity: 0.5,
      height: "100%",
      width: "100%"
    },
    calendarDates: {
      paddingLeft: 9,
      paddingRight: 9
    }
  };
});
